import React, { PureComponent } from 'react';
import { Link } from 'react-router-dom';
import ThumbUpOutlineIcon from 'mdi-react/ThumbUpOutlineIcon';
import MinusCircleOutlineIcon from 'mdi-react/MinusCircleOutlineIcon';
import { subscribeUnread } from '../../../shared/functions/unreadPoller';
import trackEvent from '../../../shared/functions/trackEvent';

// Answers worth showing off, in that order. A negative reply is a fact of the
// fundraise, not a result, so it stays in the notification center.
const RESULTS = [
  {
    key: 'positive',
    label: 'Positive',
    title: 'Investors who answered positively to your campaigns',
    icon: <ThumbUpOutlineIcon />,
  },
  {
    key: 'neutral',
    label: 'Neutral',
    title: 'Investors who answered without saying no',
    icon: <MinusCircleOutlineIcon />,
  },
];

// The results bar: how many investors have answered, split between a yes and a
// maybe, centred at the top of every page. This is where the platform shows a
// founder that the work is paying off, so it is the one place in the header
// with filled colour. Each count opens the notification center on its answers.
export default class TopbarResults extends PureComponent {
  state = { replies: null };

  componentDidMount = () => {
    this.unsubscribe = subscribeUnread(({ replies }) => {
      this.setState({ replies });
    });
  };

  componentWillUnmount = () => {
    if (this.unsubscribe) this.unsubscribe();
  };

  render() {
    const { replies } = this.state;
    if (!replies) return null;

    const shown = RESULTS.filter(result => replies[result.key] > 0);
    if (shown.length === 0) return null;

    return (
      <div className="topbar__results">
        {shown.map(result => (
          <Link
            key={result.key}
            className={`topbar__results-item topbar__results-item--${result.key}`}
            to={`/notifications?sentiment=${result.key}`}
            title={result.title}
            onClick={() => trackEvent('results_bar_clicked', { sentiment: result.key, count: replies[result.key] })}
          >
            <span className="topbar__results-icon">{result.icon}</span>
            <span className="topbar__results-count">{replies[result.key]}</span>
            <span className="topbar__results-label">{result.label}</span>
          </Link>
        ))}
      </div>
    );
  }
}
